"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUrl = void 0;
var validateUrl = function (url) {
    try {
        // Декодируем URL и создаем объект URL для проверки
        var decodedUrl = decodeURIComponent(url);
        new URL(decodedUrl);
        // Проверяем на наличие потенциально опасных символов и последовательностей
        var dangerousPatterns = [
            '<script',
            'javascript:',
            'data:',
            'vbscript:',
            'onclick',
            'onerror',
            'onload',
            'eval(',
            'alert(',
        ];
        var lowerUrl = decodedUrl.toLowerCase();
        var hasScriptInjection = dangerousPatterns.some(function (pattern) { return lowerUrl.includes(pattern); });
        if (hasScriptInjection) {
            return false;
        }
        return true;
    }
    catch (error) {
        return false;
    }
};
exports.validateUrl = validateUrl;
